import React, { createContext } from 'react';

export const LocaleContext = createContext({});

const LocaleProvider = ({ content, children }) => <LocaleContext.Provider value={{ ...content }}>{children}</LocaleContext.Provider>;

export default LocaleProvider;
